import getSampleContacts from '../constants/getSampleContacts';
function getSampleContactEmails() {
  const {
    BRIAN,
    COOL_ROBOT,
    STEPH,
    MARIA
  } = getSampleContacts();
  return [BRIAN.CONTACT_EMAIL, BRIAN.CONTACT_EMAIL_UID, COOL_ROBOT.CONTACT_EMAIL, COOL_ROBOT.CONTACT_EMAIL_UID, MARIA.CONTACT_EMAIL, MARIA.CONTACT_EMAIL_UID, STEPH.CONTACT_EMAIL];
}
export const getIsSampleContact = email => {
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
  return getSampleContactEmails().includes(email);
};